import React from "react"
import { Paper, Grid, Typography, IconButton, Avatar, Tooltip } from '@material-ui/core'
import propTypes from "prop-types"
import { SearchBox } from './SearchBox'
import useTableIcons from '../../hooks/useTableIcons'
import useStyles from "../../hooks/useStyles"

const SearchBar = ({ options, barType }) => {
    const { title, searchItems, handleSearch, spacing, variant } = options
    const classes = useStyles()
    const { tableIcons } = useTableIcons()
    const searchNodes = searchItems.map(sitem => (
        <Grid item xs={12} sm={6} md key={sitem.name}>
            <SearchBox variant={variant} {...sitem}/>
        </Grid>
    ))
    return (
        <>
            {
                barType === 'paper' ?
                    <Paper elevation={2} className={classes.searchContentRoot}>
                        <Grid container spacing={spacing ?? 3} alignItems="center">
                            <Grid item xs={12}>
                                <Typography variant="h6">
                                    {title}
                                </Typography>
                            </Grid>
                            {searchNodes}
                            <Grid item>
                                <Avatar className={classes.primaryBgTheme}>
                                    <Tooltip title={title}>
                                        <IconButton onClick={handleSearch}>
                                            <tableIcons.Search />
                                        </IconButton>
                                    </Tooltip>
                                </Avatar>
                            </Grid>
                        </Grid>
                    </Paper>
                    :
                    <Grid container spacing={spacing ?? 3} alignItems="center" className={classes.marginBottom2}>
                        <Grid item xs={12}>
                            <Typography variant="h6">
                                {title}
                            </Typography>
                        </Grid>
                        {searchNodes}
                        <Grid item>
                            <Avatar className={classes.primaryBgTheme}>
                                <Tooltip title={title}>
                                    <IconButton onClick={handleSearch}>
                                        <tableIcons.Search />
                                    </IconButton>
                                </Tooltip>
                            </Avatar>
                        </Grid>
                    </Grid>
            }
        </>
    )
}
SearchBar.defaultProps = {
    barType: 'paper'
}
SearchBar.propTypes = {
    barType: propTypes.oneOf(['paper', 'default'])
}
export { SearchBar }